var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('standart-modal',{attrs:{"id":"nav","title":_vm.$t('configuration.nav20.title'),"size":"xl","scrollable":"","lazy":"","modal-class":"nav20-config-modal"}},[_c('nav-configuration20',{attrs:{"show-title":false}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }